import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';
import '../../styles/agreementKidsCafe.css'

const KidsCafeProgramAgreement = ({
  submittedAt,
  site,
  input,
  meta: { touched, error },
}) => {
  const handleContainerOnBottom = useCallback(() => {
    if (!input.value) {
      input.onChange(true);
    }
  }, [input]);
  const containerRef = useBottomScrollListener(handleContainerOnBottom, 50);

  const replaceDate = submittedAt ? new Date(submittedAt).toLocaleDateString('en-US'):
  (new Date()).toLocaleDateString('en-US')

  return (
    <Fragment>
      <h4 className="purple-headline boxed-in">The Agreement</h4>
      <p>
        This document is an agreement made between the Houston Food Bank (hereinafter referred
        to as “HFB”) located at 535 Portwall St. Houston, TX 77029 and your site (hereinafter
        referred to as “Kids Cafe Partner Site”).
      </p>
      <div ref={containerRef} className="agreement-div scroll">
        <>
        <div className="hfb-logo" style={{display:'flex'}}><div><img
            width={150} alt="logo"
            src="data:image/jpg;base64,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"
          /></div><div style={{marginLeft:'70%'}}><img
            width={150} alt="logo"
            src="data:image/jpg;base64,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"
          /></div>
        </div>

          <h1
            style={{
              paddingTop: "3pt",
              textIndent: "0pt",
              lineHeight: "200%",
              textAlign: "center"
            }}
          >
            Kids Cafe Program Agreement Houston Food Bank Kids Cafe
          </h1>
          <p
            style={{
              paddingTop: "1pt",
              paddingLeft: "6pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            The terms of the following Agreement have been agreed upon and understood by{" "}
            <u>
              <b>The Houston Food Bank</b>
            </u>
            <b> </b>and <b>{site? site.name: ''}</b>
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "6pt",
              textIndent: "0pt",
              lineHeight: "112%",
              textAlign: "left"
            }}
          >
            By signing this agreement, both parties acknowledge their respective duties
            and responsibilities related to the administration of Kids Cafe, a Food Bank
            program of Feeding America. Kids Cafe serves nutritious meals to children at
            risk of hunger at safe, accessible sites that also agree to participate in
            nutrition education and enrichment opportunities.
          </p>
          <p
            style={{
              paddingTop: "10pt",
              paddingLeft: "6pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            The Program Host Site/Kids Cafe site agrees to:
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <ol id="l1">
            <li data-list-text={1}>
              <p
                style={{ paddingLeft: "42pt", textIndent: "-17pt", textAlign: "left" }}
              >
                Serve healthy, nutritious meals to children, provided by the Houston
                Food Bank (HFB) free of charge at all times.
              </p>
            </li>
            <li data-list-text={2}>
              <p
                style={{
                  paddingTop: "1pt",
                  paddingLeft: "42pt",
                  textIndent: "-17pt",
                  textAlign: "left"
                }}
              >
                Ensure the site complies with all applicable federal and local statutes,
                ordinances and regulations.
              </p>
            </li>
            <li data-list-text={3}>
              <p
                style={{
                  paddingTop: "1pt",
                  paddingLeft: "43pt",
                  textIndent: "-18pt",
                  lineHeight: "112%",
                  textAlign: "left"
                }}
              >
                Ensure National Background Check is completed on staff and volunteers
                with direct repetitive contact with children.
              </p>
            </li>
            <li data-list-text={4}>
              <p
                style={{ paddingLeft: "42pt", textIndent: "-17pt", textAlign: "left" }}
              >
                Must not be listed on the Texas Department of Agriculture National
                Disqualified List.
              </p>
            </li>
            <li data-list-text={5}>
              <p
                style={{
                  paddingTop: "1pt",
                  paddingLeft: "42pt",
                  textIndent: "-17pt",
                  textAlign: "left"
                }}
              >
                Maintain adequate staffing to effectively administer the Kids Cafe
                program.
              </p>
            </li>
            <li data-list-text={6}>
              <p
                style={{
                  paddingTop: "1pt",
                  paddingLeft: "42pt",
                  textIndent: "-17pt",
                  textAlign: "left"
                }}
              >
                Complete required Kids Cafe program trainings in accordance with federal
                regulations:
              </p>
              <ol id="l2">
                <li data-list-text="a.">
                  <p
                    style={{
                      paddingTop: "1pt",
                      paddingLeft: "97pt",
                      textIndent: "-18pt",
                      lineHeight: "112%",
                      textAlign: "left"
                    }}
                  >
                    Child and Adult Care Program or Summer Food Service Program
                    Training, whichever is applicable, provided by the Houston Food
                    Bank.
                  </p>
                </li>
                <li data-list-text="b.">
                  <p
                    style={{
                      paddingLeft: "96pt",
                      textIndent: "-17pt",
                      lineHeight: "11pt",
                      textAlign: "left"
                    }}
                  >
                    At least one on-site representative must complete food safety
                    training through an accredited program.
                  </p>
                </li>
              </ol>
            </li>
            <li data-list-text={7}>
              <p
                style={{
                  paddingTop: "1pt",
                  paddingLeft: "42pt",
                  textIndent: "-17pt",
                  textAlign: "left"
                }}
              >
                Maintain federal, state, and/or local licensing to provide childcare, or
                exemption from licensure.
              </p>
            </li>
            <li data-list-text={8}>
              <p
                style={{
                  paddingTop: "1pt",
                  paddingLeft: "42pt",
                  textIndent: "-17pt",
                  textAlign: "left"
                }}
              >
                If a nonprofit, provide tax exemption under 501(c)(3) of the Internal
                Revenue Code of 1986.
              </p>
            </li>
            <li data-list-text={9}>
              <p
                style={{
                  paddingTop: "1pt",
                  paddingLeft: "43pt",
                  textIndent: "-18pt",
                  lineHeight: "112%",
                  textAlign: "left"
                }}
              >
                Operate an after-school program for children throughout the school year
                and/or during school holidays that provides educational or enrichment
                activities.
              </p>
            </li>
            <li data-list-text={10}>
              <p
                style={{ paddingLeft: "42pt", textIndent: "-17pt", textAlign: "left" }}
              >
                Be available for an on-site monitoring visit from the Houston Food Bank
                at least 3 times during the program year.
              </p>
            </li>
            <li data-list-text={11}>
              <p
                style={{
                  paddingTop: "1pt",
                  paddingLeft: "43pt",
                  textIndent: "-18pt",
                  lineHeight: "112%",
                  textAlign: "left"
                }}
              >
                Store shelf stable meals from the Kids Cafe program in a secure,
                sanitary, and temperature-controlled location away from chemicals,
                stored 6 inches above the floor and 6 inches below the ceiling.
              </p>
            </li>
            <li data-list-text={12}>
              <p
                style={{
                  paddingLeft: "43pt",
                  textIndent: "-18pt",
                  lineHeight: "112%",
                  textAlign: "left"
                }}
              >
                Store temperature control for safety (TCS) meals from the Kids Cafe
                program in alignment with local health code regulations.
              </p>
            </li>
            <li data-list-text={13}>
              <p
                style={{
                  paddingLeft: "43pt",
                  textIndent: "-18pt",
                  lineHeight: "112%",
                  textAlign: "left"
                }}
              >
                Distribute Kids Cafe meals and/or snacks to program participants in
                accordance with the approved schedule by the Houston Food Bank, Texas
                Department of Agriculture and local health department regulations.
              </p>
            </li>
            <li data-list-text={14}>
              <p
                style={{
                  paddingLeft: "43pt",
                  textIndent: "-18pt",
                  lineHeight: "112%",
                  textAlign: "left"
                }}
              >
                Must track meal service by using the electronic meal count platform,
                Link2Feed or an approved alternative method when necessary.
              </p>
            </li>
            <li data-list-text={15}>
              <p
                style={{
                  paddingLeft: "43pt",
                  textIndent: "-18pt",
                  lineHeight: "112%",
                  textAlign: "left"
                }}
              >
                Must maintain documentation of any program related documents (sign-in
                sheets, rosters, medical statements, etc.) for at least 3 years.
              </p>
            </li>
            <li data-list-text={16}>
              <p
                style={{
                  paddingLeft: "43pt",
                  textIndent: "-18pt",
                  lineHeight: "112%",
                  textAlign: "left"
                }}
              >
                Must be available for receiving meals from the Houston Food Bank
                anywhere from 4 days (for shelf stable meals) to 4 hours prior to the
                approved meal service.
              </p>
            </li>
            <li data-list-text={17}>
              <p
                style={{
                  paddingLeft: "43pt",
                  textIndent: "-18pt",
                  lineHeight: "112%",
                  textAlign: "left"
                }}
              >
                Provide the Houston Food Bank with 7 operating days written notice via
                the <span className="s4">Request to Change</span> form of any changes to
                days/hours of operation, the number of children being served, or any
                other factors that will impact normal meal service.
              </p>
            </li>
            <li data-list-text={18}>
              <p
                style={{
                  paddingLeft: "43pt",
                  textIndent: "-18pt",
                  lineHeight: "112%",
                  textAlign: "left"
                }}
              >
                As a Houston Food Bank Partner, your site agrees to abide by the HFB
                co-branding policy outlined in this agreement will incorporate the HFB
                logo with your organization’s logo in printed and digital marketing
                assets where appropriate including social media, signage, and/or media
                mentions. See <span className="s4">Partner Co-branding and</span>{" "}
                <span className="s4">Communication Agreement</span>
              </p>
              <ol id="l3">
                <li data-list-text="a.">
                  <p
                    style={{
                      paddingLeft: "97pt",
                      textIndent: "-18pt",
                      lineHeight: "112%",
                      textAlign: "left"
                    }}
                  >
                    Agency is responsible for ensuring exterior/interior signage
                    co-branding signage is installed and maintained throughout the
                    duration of the partnership.
                  </p>
                </li>
                <li data-list-text="b.">
                  <p
                    style={{
                      paddingLeft: "97pt",
                      textIndent: "-18pt",
                      lineHeight: "112%",
                      textAlign: "left"
                    }}
                  >
                    Upon termination or end of partner agreement, all signage, flyers,
                    website, social media, and/or media mentions with HFB logo should be
                    removed or discontinued no later than 15 days (about 2 weeks) from
                    the end of the agreement. All original signage shall be returned to
                    HFB staff.
                  </p>
                </li>
              </ol>
            </li>
            <li data-list-text={19}>
              <p
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "43pt",
                  textIndent: "0pt",
                  lineHeight: "112%",
                  textAlign: "left"
                }}
              >
                I authenticate that all persons involved in the Child and Adult Care
                Food Program or Summer Food Service Program have completed the civil
                rights course located at{" "}
                <span className="s4">https://squaremeals.org/FandN-</span>
                <span className="s4">Resources/Training/Civil-Rights</span>
              </p>
              <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </li>
            <li data-list-text={20}>
              <p style={{ paddingLeft: "43pt", textIndent: "0pt", textAlign: "left" }}>
                I authenticate that the civil rights poster “And Justice for All” found
                here:{" "}
                <a
                  href="http://www.fns.usda.gov/cr/and-"
                  className="s6"
                  target="_blank"
                >
                  https://
                </a>
                <span className="s4">www.fns.usda.gov/cr/and-</span>
                <span className="s4">
                  justice-all-posters-guidance-and-translations
                </span>
                , “Building for the future” flyer, and updated WIC information have been
                distributed and/or posted in full view of all applicants/clients
                entering our agency. Please contact Kids Cafe if you require another
                translation of these forms for your client population.
              </p>
              <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </li>
            <li data-list-text={21}>
              <p style={{ paddingLeft: "43pt", textIndent: "0pt", textAlign: "left" }}>
                Grant neighbors the right to contact the partner agency governing board,
                HFB and the United States Department of Agriculture if they have a
                grievance against your agency.
              </p>
            </li>
          </ol>
          <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <h1 style={{ paddingLeft: "229pt", textIndent: "0pt", textAlign: "left" }}>
            USDA Nondiscrimination Statement
          </h1>
          <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p style={{ paddingLeft: "43pt", textIndent: "36pt", textAlign: "left" }}>
            In accordance with Federal civil rights law and U.S. Department of
            Agriculture (USDA) civil rights regulations and policies, the USDA, its
            Agencies, offices, and employees, and institutions participating in or
            administering USDA programs are prohibited from discriminating based on
            race, color, national origin, sex, disability, age, or reprisal or
            retaliation for prior civil rights activity in any program or activity
            conducted or funded by USDA.
          </p>
          <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p style={{ paddingLeft: "43pt", textIndent: "36pt", textAlign: "left" }}>
            Persons with disabilities who require alternative means of communication for
            program information (e.g. Braille, large print, audiotape, American Sign
            Language, etc.), should contact the Agency (State or local) where they
            applied for benefits. Individuals who are deaf, hard of hearing or have
            speech disabilities may contact USDA through the Federal Relay Service at
            (800) 877-8339. Additionally, program information may be made available in
            languages other than English.
          </p>
          <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p style={{ paddingLeft: "43pt", textIndent: "36pt", textAlign: "left" }}>
            <a
              href="http://www.usda.gov/oascr/how-to-file-a"
              className="a"
              target="_blank"
            >
              To file a program complaint of discrimination, complete the USDA Program
              Discrimination Complaint Form, (AD-3027) found online at: https://
            </a>
            www.usda.gov/oascr/how-to-file-a program discrimination-complaint, and at
            any USDA office, or write a letter addressed to USDA and provide in the
            letter all of the information requested in the form. To request a copy of
            the complaint form, call (866) 632-9992. Submit your completed form or
            letter to USDA by:
          </p>
          <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <ol id="l4">
            <li data-list-text="(1)">
              <p
                style={{ paddingLeft: "93pt", textIndent: "-14pt", textAlign: "left" }}
              >
                mail: U.S. Department of Agriculture
              </p>
              <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <p style={{ paddingLeft: "79pt", textIndent: "0pt", textAlign: "left" }}>
                Office of the Assistant Secretary for Civil Rights
              </p>
              <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <p style={{ paddingLeft: "79pt", textIndent: "0pt", textAlign: "left" }}>
                1400 Independence Avenue, SW Washington, D.C. 20250-9410;
              </p>
              <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </li>
            <li data-list-text="(2)">
              <p
                style={{ paddingLeft: "93pt", textIndent: "-14pt", textAlign: "left" }}
              >
                fax: (202) 690-7442; or
              </p>
              <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </li>
            <li data-list-text="(3)">
              <p
                style={{ paddingLeft: "93pt", textIndent: "-14pt", textAlign: "left" }}
              >
                <a href="mailto:program.intake@usda.gov" className="a" target="_blank">
                  email:{" "}
                </a>
                program.intake@usda.gov. This institution is an equal opportunity
                provider.
              </p>
            </li>
          </ol>
          <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            className="s2"
            style={{ paddingLeft: "7pt", textIndent: "0pt", textAlign: "left" }}
          >
            Child Care Centers
          </p>
          <ol id="l5">
            <li data-list-text={1}>
              <p
                style={{
                  paddingTop: "1pt",
                  paddingLeft: "61pt",
                  textIndent: "-18pt",
                  textAlign: "left"
                }}
              >
                Must adhere to all the above requirements.
              </p>
            </li>
            <li data-list-text={2}>
              <p
                style={{
                  paddingTop: "1pt",
                  paddingLeft: "61pt",
                  textIndent: "-18pt",
                  textAlign: "left"
                }}
              >
                Maintain federal, state, and/or local licensing to provide childcare, or
                exemption from licensure.
              </p>
            </li>
            <li data-list-text={3}>
              <p
                style={{
                  paddingTop: "1pt",
                  paddingLeft: "61pt",
                  textIndent: "-18pt",
                  textAlign: "left"
                }}
              >
                If operating an infant program:
              </p>
              <ol id="l6">
                <li data-list-text="a.">
                  <p
                    style={{
                      paddingTop: "1pt",
                      paddingLeft: "97pt",
                      textIndent: "-18pt",
                      lineHeight: "112%",
                      textAlign: "left"
                    }}
                  >
                    An MBIE and enrollment forms must be provided for each program
                    participant prior to receiving meals from the Houston Food Bank
                  </p>
                </li>
                <li data-list-text="b.">
                  <p
                    style={{
                      paddingLeft: "97pt",
                      textIndent: "-18pt",
                      lineHeight: "11pt",
                      textAlign: "left"
                    }}
                  >
                    Must provide rosters, production records, and sign in sheets on a
                    weekly basis
                  </p>
                </li>
                <li data-list-text="c.">
                  <p
                    style={{
                      paddingTop: "1pt",
                      paddingLeft: "97pt",
                      textIndent: "-18pt",
                      lineHeight: "112%",
                      textAlign: "left"
                    }}
                  >
                    For-Profit Centers must maintain a minimum of 30% of children who
                    qualify for free or reduced-price meals.
                  </p>
                </li>
              </ol>
            </li>
          </ol>
          <p
            className="s7"
            style={{ paddingLeft: "7pt", textIndent: "0pt", textAlign: "left" }}
          >
            <span></span>
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <h1 style={{ paddingLeft: "2pt", textIndent: "0pt", textAlign: "center" }}>
            Houton Food Bank Kids Cafe Program Agreement
          </h1>
          <p style={{ paddingTop: "3pt", textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <ol id="l7">
            <li data-list-text={1}>
              <p
                style={{ paddingLeft: "60pt", textIndent: "-17pt", textAlign: "left" }}
              >
                Provide healthy, nutritious meals to children 18 or younger free of
                charge.
              </p>
            </li>
            <li data-list-text={2}>
              <p
                style={{
                  paddingTop: "1pt",
                  paddingLeft: "60pt",
                  textIndent: "-17pt",
                  textAlign: "left"
                }}
              >
                Provide or coordinate applicable training opportunities for partner site
                staff and volunteers as needed.
              </p>
            </li>
            <li data-list-text={3}>
              <p
                style={{
                  paddingTop: "1pt",
                  paddingLeft: "60pt",
                  textIndent: "-17pt",
                  textAlign: "left"
                }}
              >
                Deliver meals anywhere from 4 days to 4 hours prior to the approved meal
                service time.
              </p>
            </li>
            <li data-list-text={4}>
              <p
                style={{
                  paddingTop: "1pt",
                  paddingLeft: "60pt",
                  textIndent: "-17pt",
                  textAlign: "left"
                }}
              >
                Communicate organization closures and menu adjustments within a timely
                manner.
              </p>
            </li>
            <li data-list-text={5}>
              <p
                style={{
                  paddingTop: "1pt",
                  paddingLeft: "60pt",
                  textIndent: "-17pt",
                  textAlign: "left"
                }}
              >
                Conduct unannounced monitoring visits 3 times throughout the program
                year.
              </p>
            </li>
            <li data-list-text={6}>
              <p
                style={{
                  paddingTop: "1pt",
                  paddingLeft: "61pt",
                  textIndent: "-18pt",
                  lineHeight: "112%",
                  textAlign: "left"
                }}
              >
                Houston Food Bank holds liability insurance for the services and
                programs we operate within the community. Additionally, we maintain food
                safety requirements to serve food through out partners via routine
                health department audits conducted by the City of Houston Health
                Department.
              </p>
            </li>
            <li data-list-text={7}>
              <p
                style={{
                  paddingLeft: "61pt",
                  textIndent: "-18pt",
                  lineHeight: "112%",
                  textAlign: "left"
                }}
              >
                The Houston Food Bank determines eligibility of enrolled children
                through MBIE forms on a yearly basis for childcare centers.
              </p>
            </li>
          </ol>
          <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          
          <h1
            style={{
              paddingTop: "8pt",
              paddingLeft: "2pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            Houton Food Bank Kids Cafe Program Agreement
          </h1>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "6pt",
              textIndent: "0pt",
              lineHeight: "112%",
              textAlign: "left"
            }}
          >
            This Agreement may be terminated at will by either party with written notice
            delivered to either party not less than 30 days prior to the desired date.
            Upon termination of this agreement, the Program Partner will return any
            equipment and/or materials provided by the Houston Food Bank for the Kids
            Cafe program to HFB within 30 days of termination date.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          
          <p
            style={{
              paddingLeft: "7pt",
              textIndent: "0pt",
              lineHeight: "1pt",
              textAlign: "left"
            }}
          ></p>
          <p
            style={{
              paddingTop: "2pt",
              paddingLeft: "7pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            {replaceDate}
          </p>
          <p style={{ paddingTop: "11pt", textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            className="s14"
            style={{ paddingLeft: "2pt", textIndent: "0pt", textAlign: "center" }}
          >
            This institution is an equal opportunity provider and employer.
          </p>
          <p style={{ paddingLeft: "2pt", textIndent: "0pt", textAlign: "center" }}>
            <a
              href="mailto:ahernandez@houstonfoodbank.org"
              style={{
                color: "black",
                fontFamily: "Calibri, sans-serif",
                fontStyle: "italic",
                fontWeight: "normal",
                textDecoration: "none",
                fontSize: "8pt"
              }}
              target="_blank"
            >
              Please retain a copy of this document at the school site and email to
            </a>
            <a
              href="mailto:ahernandez@houstonfoodbank.org"
              className="s15"
              target="_blank"
            >
              ahernandez@houstonfoodbank.org
            </a>
          </p>
        </>
      </div>
      {touched && error
        && (
          <span
            style={{
              color: 'red',
            }}
          >
            You must read the above Agreement
          </span>
        )
      }
    </Fragment>
  );
};

KidsCafeProgramAgreement.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
};

export default KidsCafeProgramAgreement;
